import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=50f83d84&scoped=true"
import script from "./Packaging.vue?vue&type=script&lang=js"
export * from "./Packaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f83d84",
  null
  
)

export default component.exports